import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreLabel?: string;
  moreTo?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreLabel,
  moreTo,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-10 h-10 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
            <i className={`${icon} text-xl`} />
          </span>
        )}
        <div>
          <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950 leading-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {moreLabel && moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}